import { backendClient } from '@neptune/shared/core-apis-backend-domain';

export async function cancelSubscription(): Promise<void> {
  return backendClient.cancelSubscription();
}
